import { Paper, Grid, Typography } from "@mui/material";

import { ComponentCard } from "./ComponentCard";
import { Component } from "../../../../types/component";
import { Airframe } from "../../../../types/airframe";
import type { DisplayPreferences } from "../../../../hooks/useTenantDisplayPreferences";

type Props = {
  loading: boolean;
  components: Component[];
  onEdit: (c: Component) => void;
  onDelete: (c: Component) => void;
  onMiniPack: (c: Component) => void;
  airframes?: Airframe[];
  displayPreferences: DisplayPreferences;
};

export function ComponentGrid({ loading, components, airframes = [], displayPreferences, ...actions }: Readonly<Props>) {
  if (loading) return <Typography sx={{ color: "#fff" }}>Loading...</Typography>;
  if (!components.length) return <Typography sx={{ color: "#fff" }}>No components</Typography>;

  return (
    <Paper
      sx={{
        flex: 1,
        p: 2,
        backgroundColor: "#111",
        border: "1px solid #333",
        overflow: "auto",
      }}
    >
      <Grid container spacing={2}>
        {components.map((c) => (
          <Grid key={c.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <ComponentCard component={c} airframes={airframes} displayPreferences={displayPreferences} {...actions} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
